import { render } from "./CourseDetailPage.vue?vue&type=template&id=113be52b&scoped=true"
import script from "./CourseDetailPage.vue?vue&type=script&lang=js"
export * from "./CourseDetailPage.vue?vue&type=script&lang=js"

import "./CourseDetailPage.vue?vue&type=style&index=0&id=113be52b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113be52b"]])

export default __exports__